/**
 * Encripta datos usando RSA-OAEP con Web Crypto API (nativo del navegador)
 * No requiere librerías externas
 */

// Convierte base64 a ArrayBuffer
function base64ToArrayBuffer(base64) {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i += 1) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

// Convierte ArrayBuffer a base64 URL-safe
function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
}

/**
 * Encripta un objeto de datos usando RSA
 * @param {Object} data - Objeto con los datos a encriptar
 * @returns {Promise<string>} - String encriptado en base64 URL-safe
 */
export async function encryptData(data) {
  try {
    // Obtiene la clave pública del .env
    const publicKeyBase64 = import.meta.env.VITE_PUBLIC_KEY;
    if (!publicKeyBase64) {
      throw new Error('VITE_PUBLIC_KEY no configurada en el archivo .env');
    }
    
    // Importa la clave pública
    const publicKey = await window.crypto.subtle.importKey(
      'spki',
      base64ToArrayBuffer(publicKeyBase64),
      {
        name: 'RSA-OAEP',
        hash: 'SHA-256',
      },
      false,
      ['encrypt']
    );
    
    // Convierte los datos a JSON y luego a ArrayBuffer
    const encoder = new TextEncoder();
    const dataBuffer = encoder.encode(JSON.stringify(data));
    
    // Encripta con RSA-OAEP
    const encrypted = await window.crypto.subtle.encrypt(
      {
        name: 'RSA-OAEP',
      },
      publicKey,
      dataBuffer
    );
    
    // Convierte a base64 URL-safe
    return arrayBufferToBase64(encrypted);
  } catch (error) {
    console.error('Error al encriptar:', error);
    throw error;
  }
}

